<template>
  <div style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-header height="20%"  class="padding">
        <div style="display: flex;flex-direction:column;margin-top: 50px;">
          <img style="width: 256px;height: 84px;margin-left: 10px;" src="/wall/空白.png">
        </div>
        <div style="color: #2b8ad7;text-align:center;display: flex;flex-wrap: wrap;justify-content: center">
          <div style="font-size: 80px;">CW 生产考勤系统</div>
          <div style="width: 280px;font-weight:bold;font-size: 35px;position: absolute;margin-left: 78%">{{ currentTime }}</div>
        </div>
      </el-header>
      <el-main height="55%" class="padding">
        <el-row style="margin-top: 12%;text-align: center;">
          <el-col :span="12">
            <el-button class="btn_1" @click="JGGoLive">切断/加工上线</el-button>
          </el-col>
          <el-col :span="12">
            <el-button class="btn_2" @click="JGOffline">切断/加工下线</el-button>
          </el-col>
        </el-row>
      </el-main>
      <el-footer height="25%" style="text-align: center" >
        <img style="height: 100%;width: 95%" src="/wall/空白.png" alt="">
      </el-footer>
    </el-container>
  </div>
  <el-dialog width="70%" :lock-scroll="false" title="上线登记" :close-on-click-modal="false" :before-close="onlineHandleClose" v-model="onlineVisible">
    <el-button style="text-align: left;background-color: #2bd82f;color: white;border-radius: 8px;width: 150px;font-size: 25px" size="large">上线登记</el-button>
    <el-row>
      <el-col :span="24">
        <h2 style="font-weight: bold;text-align: center;font-size: 35px">【请扫描工牌】</h2>
      </el-col>
    </el-row>
    <div style="margin-top: -5%;margin-left: 83%;">
      <div style="font-weight: bold;font-size: 25px;text-align: center;height: 80px;width: 150px;border-left: #2bd82f 2px solid;border-right: #2bd82f 2px solid;border-bottom: #2bd82f 2px solid;color: white;">
        <el-button style="margin-top: -30px;background-color: #2bd82f;color: white;border-radius: 16px;width: 150px;font-size: 25px;margin-left: -2px;" size="large">上线人数</el-button>
        <div style="color: #2bd82f;margin-top: -6px;">{{onlinePeoples}}</div>
      </div>
    </div>
    <el-table stripe border :header-cell-style="{textAlign: 'center', fontSize: '20px'}"
              :cell-style="{ textAlign: 'center', width: '100%', fontSize: '18px'}" style="overflow-y: auto;height: 400px" v-loading="onlineTableLoading" :data="onlineTableData">
      <el-table-column prop="user_name" label="工号" min-width="160"/>
      <el-table-column prop="name" label="姓名" min-width="160"/>
      <el-table-column prop="go_live_time" label="上线时间" min-width="200"/>
    </el-table>
  </el-dialog>

  <el-dialog width="70%" :lock-scroll="false" title="下线登记" :close-on-click-modal="false"  :before-close="offlineHandleClose" v-model="offlineVisible">
    <el-button style="text-align: left;background-color: #0e91df;color: white;border-radius: 8px;width: 150px;font-size: 25px" size="large">下线登记</el-button>
    <el-row>
      <el-col :span="24">
        <h2 style="font-weight: bold;text-align: center;font-size: 35px">【请扫描工牌】</h2>
      </el-col>
    </el-row>
    <div style="margin-top: -5%;margin-left: 83%;">
      <div style="font-weight: bold;font-size: 25px;text-align: center;height: 80px;width: 150px;border-left: #0e91df 2px solid;border-right: #0e91df 2px solid;border-bottom: #0e91df 2px solid;color: white">
        <el-button style="margin-top: -30px;background-color: #0e91df;color: white;border-radius: 16px;width: 150px;font-size: 25px;margin-left: -2px;" size="large">下线人数</el-button>
        <div style="color: #0e91df;margin-top: -6px;">{{offlinePeoples}}</div>
      </div>
    </div>
    <el-table stripe border :header-cell-style="{textAlign: 'center', fontSize: '20px'}"
              :cell-style="{ textAlign: 'center', width: '100%', fontSize: '18px'}" style="overflow-y: auto;height: 400px" v-loading="offlineTableLoading" :data="offlineTableData">
      <el-table-column prop="user_name" style="font-size: 30px" label="工号" min-width="160"/>
      <el-table-column prop="name" label="姓名" min-width="160"/>
      <el-table-column prop="go_live_time" label="上线时间" min-width="200"/>
      <el-table-column prop="off_line_time" label="下线时间" min-width="200"/>
    </el-table>
  </el-dialog>
</template>

<script>

import {useDateFormat} from "@vueuse/core";

export default {
  name: "JGHomePage",
  components: {},
  data() {
    return {
      currentTime: '',
      scanName: '',
      onlineTableData: [],
      onlinePeoples:0,
      offlineTableData: [],
      offlinePeoples:0,
      onlineVisible: false,
      offlineVisible: false,
      onlineTableLoading: false,
      offlineTableLoading:false,
    }
  },
  mounted() {
    // 在组件挂载后执行的生命周期钩子函数
    this.addKeyboardListener();
  },
  methods: {
    addKeyboardListener() {
      document.addEventListener('keydown', this.handleKeyDown);
    },
    dateFormat() {
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
    onlineHandleClose() {
      this.onlineVisible = false;
    },
    offlineHandleClose() {
      this.offlineVisible = false;
    },
    //上线
    JGGoLive() {
      this.onlineVisible = true;
      this.getOnlineTableData();
    },
    //下线
    JGOffline() {
      this.offlineVisible = true;
      this.getOfflineTableData()
    },
    getOnlineTableData() {
      this.$axios.get('jg/getOnlineTableData').then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.onlineTableData = res.data;
        this.getOnlinePeoples();
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getOnlinePeoples() {
      this.$axios.get('jg/getOnlinePeoples').then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.onlinePeoples = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getOfflineTableData() {
      this.$axios.get('jg/getOfflineTableData').then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.offlineTableData = res.data;
        this.getOfflinePeoples();
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getOfflinePeoples() {
      this.$axios.get('jg/getOfflinePeoples').then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.offlinePeoples = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    handleKeyDown(event) {
      if (event.keyCode === 13) {
        if (this.scanName.length !== 0) {
          if (this.onlineVisible) {
            this.addOnlineEmployees();
          } else if (this.offlineVisible) {
            this.addOfflineEmployees();
          } else {
            this.$message.error("当前状态不可扫码")
            this.scanName = '';
          }
        }
      } else if (event.keyCode !== 16) {
        this.scanName += event.key
      }
    },
    removeKeyboardListener() {
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
      // 在组件销毁前执行的生命周期钩子函数
      this.removeKeyboardListener();
    },
    addOnlineEmployees() {
      this.onlineTableLoading = true;
      this.$axios.post('jg/addOnlineEmployees', this.scanName).then(response => {
        this.onlineTableLoading = false;
        let res = response.data;
        if (res.code !== 0) {
          this.scanName = '';
          return this.$message.error(res.message);
        }

        this.tableData = res.data;
        this.getOnlineTableData()
        this.scanName = '';
        this.$message.success("上线成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.scanName = '';
      })
    },
    addOfflineEmployees() {
      this.offlineTableLoading = true;
      this.$axios.post('jg/addOfflineEmployees', this.scanName).then(response => {
        this.offlineTableLoading = false;
        let res = response.data;
        if (res.code !== 0) {
          this.scanName = '';
          return this.$message.error(res.message);
        }

        this.offlineTableData = res.data;
        this.getOfflineTableData()
        this.scanName = '';
        this.$message.success("下线成功")
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.scanName = '';
      })
    },
  },
  created() {
    this.timer1 = setInterval(() => {
      this.dateFormat();
    }, 1000)
  }
}
</script>

<style scoped>
.padding {
  padding: 0;
}

.btn_1 {
  background-color: #2bd82f;
  color: white;
  width: 400px;
  height: 200px;
  font-size: 60px;
  border-radius: 20px;
}

.btn_2 {
  background-color: #0e91df;
  color: white;
  width: 400px;
  height: 200px;
  font-size: 60px;
  border-radius: 20px;
}


</style>